import ActionElement from '~/helpers/workareaDiagram/actionElement';
import DiagramElement from '~/helpers/workareaDiagram/diagramElement';
import StepElement from '~/helpers/workareaDiagram/stepElement';
import WorkareaDiagram from '~/helpers/workareaDiagram/workareaDiagram';
import IWorkflowStepContainer from "./iworkflowStepContainer";
import WorkflowConst from "./workflowConst";
import WorkflowStep from "./workflowStep";
import ProcessFlowConst from '../../../processFlowBuilder/helpers/processFlowDiagram/processFlowConst'
import DiagramConst from '~/helpers/workareaDiagram/diagramConst'

export class DisconnectedTitleCoordinate extends DiagramElement implements IWorkflowStepContainer{
  nextSteps: IWorkflowStepContainer[];
  isTermination: boolean = true;

  constructor(steps) {
    super();
    this.nextSteps = steps;
  }
  get const() {
    return WorkflowConst
  }

  get stepWidth() {
    return this.const.StepWidth;
  }

  get stepHeight() {
    return this.const.StartHeight;
  }

  get fullStepWidth() {
    return 500;
  }

  get titleOrDefault() {
    return 'Disconnected';
  }
  get client_id() {
    return `disconnected_${this.coordinates[1]}`;
  }
}

export class WorkflowCoordinate extends StepElement {
  step: WorkflowStep;

  constructor(parent: DiagramElement, step: WorkflowStep, isTermination: boolean, graphParent: DiagramElement) {
    super(parent, step, isTermination, graphParent);
  }

  get const() {
    return WorkflowConst
  }

  get stepWidth() {
    return this.const.StepWidth;
  }

  get stepHeight() {
    return this.const.StepHeight;
  }

  get fullStepWidth() {
    return this.isTermination ? 250 : 500;
  }

  get jumpFrom() {
    const parent = this.parent as WorkflowCoordinate;
    if (parent.step.defaultAction.jump_to.to_client_id === this.step.client_id) {
      return parent.step.defaultAction.jump_to;
    } else {
      const conditionalRuleSets = parent.step.defaultAction.jump_to_conditional_rule_sets;
      const sets = Object.keys(conditionalRuleSets).map(k => conditionalRuleSets[k]);
      for (const set of sets) {
        if (set.jump_to_client_id === this.step.client_id) {
          return set.jump_to;
        }
      }
    }
  }

  get title() {
    if (this.isTermination) {
      return this.isWorkflowStep ? `Back to ${this.step.titleOrDefault}` : 'END';
    }
    return this.step.titleOrDefault;
  }

  get client_id() {
    return `${this.isWorkflowStep ? this.step.client_id : '_end'}_${this.index}`;
  }

  get isWorkflowStep() {
    return this.step instanceof WorkflowStep;
  }

  get hasActions(): boolean {
    return Object.keys(this.step.actions).length > 1;
  }
}

export class ActionCoordinate extends ActionElement {
  action: IWorkflowStepContainer;

  constructor(parent: DiagramElement, action: IWorkflowStepContainer, graphParent: DiagramElement) {
    super();
    this.parent = parent;
    if (parent) {
      parent.children.push(this);
    }
    this.action = action;
    this.graphParent = graphParent
  }

  get const(): typeof DiagramConst {
    return WorkflowConst
  }

  get stepWidth() {
    return this.const.EndStepWidth;
  }

  get stepHeight() {
    return this.const.ActionHeight;
  }

  get fullStepWidth() {
    return 250;
  }

  get title() {
    return this.action.titleOrDefault;
  }
  get client_id() {
    return this.action.client_id;
  }

  get step() {
    return this.action;
  }
}

export class ProcessFlowActionCoordinate extends ActionCoordinate {
  get const() {
    return ProcessFlowConst
  }
}

export default class WorkflowGraph extends WorkareaDiagram {
  initialStep: WorkflowStep;

  constructor(initialStep: WorkflowStep, initialStepCoords: number[]) {
    super()
    this.initialStep = initialStep;
    this.initialStepCoords = initialStepCoords;
  }

  get const() {
    return WorkflowConst
  }

  get initialElementClass() {
    return this.stepElementClass
  }

  get stepClass() {
    return WorkflowStep
  }

  get stepElementClass() {
    return WorkflowCoordinate
  }

  brokenWorkFlowSteps(){
    const workflowGraph = this;
    let allSteps = this.brokenWorkFlowCoords().map(x => x === workflowGraph.initialStepCoords ? workflowGraph.initialStep :  x.step);
    let brokenSteps = allSteps.filter((value, index, self) => self.indexOf(value) === index);
    return brokenSteps;
  }

  get stepNodeHeight(): number {
    return this.const.StepHeight +
      this.const.StepBorderWidth * 2 +
      this.const.PlusLineLength +
      this.const.ArrowPointerLength +
      this.const.ArrowPointerOffset
  }

  get allSteps() {
    return this.initialStep.rootModel.workflow_steps;
  }

  get startNodeHeight(): number {
    // not used
    return null
  }

  isLinkConfigurable(step): boolean {
    return true
  }
}